<template>
  <vx-card :title="$t('live-class-schedule.live-host')" class="mb-4">

    <vs-avatar :src="teacher ? getAvatarUrl(teacher.picturePath):''"
               class="mx-auto mb-6 block"
               size="80px"/>

    <div class="text-center mb-2">
      <ValidationProvider :name="$t('class-room.teacher-description')" rules="required" v-slot="{ errors }">
        <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :name="$t('class-room.teacher-description')"
                  :options="teachers"
                  class="w-full mb-1"
                  selectOnTab
                  label="firstNameLocal"
                  v-model="teacherEdit.selectedTeacher">
          <!--label option-->
          <template #selected-option="{ firstNameLocal, lastNameLocal }">
            {{ firstNameLocal }} {{ lastNameLocal }}
          </template>

          <!--option list-->
          <template v-slot:option="option">
            {{ option.code }} {{ option.firstNameLocal }} {{ option.lastNameLocal }}
          </template>

        </v-select>

        <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
      </ValidationProvider>
      <p class="text-grey" v-if="teacher">{{ teacher.code }}</p>
    </div>

    <div v-if="teacher && teacher.telephone">
            <span class="flex items-center mb-1">
              <feather-icon icon="PhoneIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
              <span class="ml-2 inline-block  text-sm" v-if="teacher">
                {{ teacher.telephone ? teacher.telephone:'-' }}
              </span>
            </span>
    </div>
    <div v-if="teacher && teacher.email">
            <span class="flex items-center mb-1">
              <feather-icon icon="MailIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
              <span class="ml-2 inline-block text-sm" v-if="teacher">
                {{ teacher.email ? teacher.email:'-' }}
              </span>
            </span>
    </div>
    <div v-if="teacher && teacher.socialMedia">
            <span class="flex items-center mb-1">
              <feather-icon icon="SmartphoneIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
              <span class="ml-2 inline-block text-sm" v-if="teacher">
                {{ teacher.socialMedia }}
              </span>
            </span>
    </div>
    <vs-divider/>
    <div class="flex justify-between flex-wrap">
              <span>
                  <p class="text-l" v-if="teacher && teacher.availableTime">
                    {{ teacher.availableTime }}
                  </p>
                  <p class="text-l" v-else>-</p>
                  <p class="text-grey">{{ $t('teacher.availableTime') }}</p>
              </span>
      <span>
                  <p class="text-l" v-if="teacher">
                    {{ teacher.isSpecialTeacher ? $t('teacher.type.normal'):$t('teacher.type.special') }}
                  </p>
                  <p class="text-l" v-else>-</p>
                  <p class="text-grey">{{ $t('teacher.type.type') }}</p>
              </span>
    </div>
  </vx-card>
</template>

<script>
  import {state, initData} from '../data';
  import Teacher from '@/store/modules/profile/teacher';
  import {createHelpers} from "vuex-map-fields";
  import {createNamespacedHelpers} from 'vuex';
  import vSelect from 'vue-select';
  import {getAvatarUrl} from "@/utils/upload";

  if (!state.store.Teacher) state.registerModule(`Teacher`, Teacher);

  const {
    mapActions: mapTeacherActions,
  } = createNamespacedHelpers(`Teacher`);

  const {
    mapFields: mapTeacherFields,
  } = createHelpers({
    getterType: `Teacher/getField`,
    mutationType: `Teacher/updateField`,
  });

  export default {
    props: {
      parentMethods: Object,
    },
    components: {
      vSelect,
    },
    data() {
      return {
        local: state.local,
        store: state.store,

        getAvatarUrl: getAvatarUrl,
        classRoomEdit: state.local.classRoomEdit,
        teacherEdit: state.local.teacherEdit,
      }
    },
    computed: {
      ...mapTeacherFields({teacherProcessing: 'processing'}),
      teachers() {
        return state.store.Teacher.teachersDdl;
      },
      teacher() {
        return this.teacherEdit.selectedTeacher;
      }
    },
    watch: {
      teacherProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      ...mapTeacherActions({
        getTeachersDdl: 'getTeachersDdl',
      }),
      async onSelectedTeacher() {

      },
      //------------------------------------ Local Function ----------------------------------------------------------//
      async initData() {
        let initFunction = {
          getTeachersDdl: this.getTeachersDdl,
        };
        //state variable
        await initData(initFunction);
      },
    },
    async mounted() {
      //call local function init all data
      await this.initData();
    }
  }
</script>

<style scoped>
</style>
